import React from "react";

function QuickActionsWrapper({ children }: { children: React.ReactNode }) {
  return (
    <div
      onClick={(e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      className="flex gap-2"
    >
      {children}
    </div>
  );
}

export default QuickActionsWrapper;
